<div>
	<span>
		{{ getData().draftSavedSuccessMessage }}
	</span>
</div>
<div class="draft-follow-up">
	<span class="draft-follow-up-text">
		{{ getData().draftEditMessageTextLine1 }}
	</span>
	<a class="draft-list-link" (click)="$event.preventDefault();navigateToDraftListView()" href="#">
		<span>{{ getData().draftListLinkText }}</span>
	</a>
	<span *ngIf="!showFeedback()" class="draft-follow-up-text">
		{{ getData().draftEditMessageTextLine2 }}
	</span>
</div>
<div class="snackbar-link-align-right">
	<button type="submit" mat-button class="button-link-margin" (click)="dismiss()">
		<span translate>ok.value</span>
	</button>
</div>